/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Health_UnavailableInputs */

const id_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak tersedia`)
};

const ms_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak tersedia`)
};

const da_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilgængelig`)
};

const de_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht verfügbar`)
};

const en_us2_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unavailable`)
};

const es_es2_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disponible`)
};

const es_mx2_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No disponible`)
};

const fil_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi available`)
};

const fr_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indisponible`)
};

const it_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non disponibile`)
};

const hu_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem érhető el`)
};

const nl_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet beschikbaar`)
};

const no_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilgjengelig`)
};

const pl_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedostępny`)
};

const pt_br2_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indisponível`)
};

const pt_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indisponível`)
};

const ro_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indisponibil`)
};

const fi_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei saatavilla`)
};

const sv_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inte tillgänglig`)
};

const vi_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không khả dụng`)
};

const tr_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanılamıyor`)
};

const cs_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedostupný`)
};

const bg_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недостъпна`)
};

const ru_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недоступен`)
};

const uk_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недоступний`)
};

const ar_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير متاح`)
};

const hi_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुपलब्ध`)
};

const th_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พร้อมใช้งาน`)
};

const ja_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用不可`)
};

const zh_cn2_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不可用`)
};

const zh_hant1_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法使用`)
};

const ko_builds_health_unavailable = /** @type {(inputs: Builds_Health_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용할 수 없음`)
};

/**
* | output |
* | --- |
* | "Unavailable" |
*
* @param {Builds_Health_UnavailableInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_health_unavailable = /** @type {((inputs?: Builds_Health_UnavailableInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Health_UnavailableInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_health_unavailable(inputs)
	if (locale === "ms") return ms_builds_health_unavailable(inputs)
	if (locale === "da") return da_builds_health_unavailable(inputs)
	if (locale === "de") return de_builds_health_unavailable(inputs)
	if (locale === "en-US") return en_us2_builds_health_unavailable(inputs)
	if (locale === "es-ES") return es_es2_builds_health_unavailable(inputs)
	if (locale === "es-MX") return es_mx2_builds_health_unavailable(inputs)
	if (locale === "fil") return fil_builds_health_unavailable(inputs)
	if (locale === "fr") return fr_builds_health_unavailable(inputs)
	if (locale === "it") return it_builds_health_unavailable(inputs)
	if (locale === "hu") return hu_builds_health_unavailable(inputs)
	if (locale === "nl") return nl_builds_health_unavailable(inputs)
	if (locale === "no") return no_builds_health_unavailable(inputs)
	if (locale === "pl") return pl_builds_health_unavailable(inputs)
	if (locale === "pt-BR") return pt_br2_builds_health_unavailable(inputs)
	if (locale === "pt") return pt_builds_health_unavailable(inputs)
	if (locale === "ro") return ro_builds_health_unavailable(inputs)
	if (locale === "fi") return fi_builds_health_unavailable(inputs)
	if (locale === "sv") return sv_builds_health_unavailable(inputs)
	if (locale === "vi") return vi_builds_health_unavailable(inputs)
	if (locale === "tr") return tr_builds_health_unavailable(inputs)
	if (locale === "cs") return cs_builds_health_unavailable(inputs)
	if (locale === "bg") return bg_builds_health_unavailable(inputs)
	if (locale === "ru") return ru_builds_health_unavailable(inputs)
	if (locale === "uk") return uk_builds_health_unavailable(inputs)
	if (locale === "ar") return ar_builds_health_unavailable(inputs)
	if (locale === "hi") return hi_builds_health_unavailable(inputs)
	if (locale === "th") return th_builds_health_unavailable(inputs)
	if (locale === "ja") return ja_builds_health_unavailable(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_health_unavailable(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_health_unavailable(inputs)
	return ko_builds_health_unavailable(inputs)
});
export { builds_health_unavailable as "builds.health.unavailable" }